<script>
export default {
  name: "LoaderInline",

  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<template>
  <div v-if="loading" class="loader-wrapper">
    <span class="loader-wrapper__loader-icon" />
  </div>
</template>

<style lang="scss" scoped>
.loader-wrapper {
  &__loader-icon {
    position: absolute;
    width: 100px;
    height: 100px;
    top: 50%;
    left: 50%;
    transform: translate(-50%);
    background: url("../assets/icons/loader.svg") center / contain no-repeat;
  }
}
</style>
